export default __webpack_public_path__ + "static/media/logo.2961fe9a.png";